import axios from '@axios'

export const state = {
  announcements: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 0,
  totalRecords: 0,
}
export const getters = {
  allAnnouncements: (state) => state.announcements,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}
export const mutations = {
  GET_ANNOUNCEMENTS: (state, data) => {
    // console.log(data)
    state.announcements = data.announcements
    state.currentPage = data.page
    state.perPage = data.perPage
    state.totalPages = data.totalPages
    state.totalRecords = data.totalRecords
  },

  CREATE_ANNOUNCEMENT: (state, announcement) => {
    state.announcements.unshift(announcement)
  },

  UPDATE_ANNOUNCEMENT: (state, announcement) => {
    state.announcements = state.announcements.filter(
      (c) => c.id !== announcement.id
    )
    state.announcements.unshift(announcement)
  },

  REMOVE_ANNOUNCEMENT: (state, announcement) => {
    state.announcements = state.announcements.filter(
      (c) => c.id !== announcement.id
    )
  },

  RESTORE_ANNOUNCEMENT: (state, announcement) => {
    state.announcements = state.announcements.filter(
      (c) => c.id !== announcement.id
    )
    state.announcements.unshift(announcement)
  },
}

export const actions = {
  async getAnnouncement({ commit }, id) {
    return axios.get(`/announcements/${id}`)
  },

  async getAnnouncements({ commit }, params = {}) {
    await axios
      .get(`/announcements`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = resp.data
          commit('GET_ANNOUNCEMENTS', data)
        }
      })
      .catch(() => {
        commit('GET_ANNOUNCEMENTS', null)
      })
  },

  async createAnnouncement({ commit }, announcement) {
    await axios.post('/announcements', announcement).then((response) => {
      if (response.status === 201) {
        commit('CREATE_ANNOUNCEMENT', response.data)
      }
    })
  },

  async updateAnnouncement({ commit }, announcement) {
    await axios.put(`/announcements`, announcement).then((response) => {
      if (response.status === 200) {
        commit('UPDATE_ANNOUNCEMENT', response.data)
      }
    })
  },

  async removeAnnouncement({ commit }, announcement) {
    await axios
      .delete('/announcements', { data: announcement })
      .then((resp) => {
        if (resp.status === 204) commit('REMOVE_ANNOUNCEMENT', announcement)
      })
  },

  async restoreTrash({ commit }, announcement) {
    await axios.patch('/announcements', announcement).then((response) => {
      if (response.status === 200) {
        commit('RESTORE_ANNOUNCEMENT', response.data)
      }
    })
  },
}
